import gql from 'graphql-tag';

export default gql`
query getCustomCssOfFoldersAndProjects($folderIds: [Int!], $projectIds: [Int!]) {
  # Ids for the root-first order by item path (joinCustomCss).
  folders(where: {folder_id: {_in: $folderIds}}) {
    folder_id
    custom_css
  }
  projects(where: {project_id: {_in: $projectIds}}) {
    project_id
    custom_css
  }
}
`;
